import React from "react";
import { useTranslation } from "react-i18next";
import { MyResult } from "../apis/BreefApis";

/**
 * The level card: the heading and the level's name over the breefer in its circle, "POINT" and the score under
 * it. The words used to be drawn into the picture (nine pictures, "Level N af 35" baked in); now the picture
 * holds only the figure and the words come from admin → Levels, in the same face and at the same places as
 * before (measured on the old pictures, as a share of the height).
 */
export const LevelCard: React.FC<{ level: MyResult["level"] | null; children?: React.ReactNode }> = ({ level, children }) => {
  const [t] = useTranslation("global");
  const name = level?.name || (level ? t("gameResult.level", { number: level.number, of: level.of }) : "");
  return (
    <div className="result-card">
      <p className="result-heading">{level?.heading || t("gameResult.heading")}</p>
      <p className="result-name">{name}</p>
      {level?.name && <p className="result-level">{t("gameResult.level", { number: level.number, of: level.of })}</p>}
      {level?.imageUrl && <img className="result-picture" src={level.imageUrl} alt="" />}
      <p className="result-point">{t("gameResult.points")}</p>
      {children}
    </div>
  );
};
